import { Component, Input } from "@angular/core";

@Component({
  selector: "app-notification-card",
  templateUrl: "./notification-card.component.html",
})
export class NotificationCardComponent {
  // Horizontal padding (left/right value) used in the main heading's padding shorthand.
  @Input() headingPadding = "175px";
  // Main heading text.
  @Input() heading = "Reminder That You’re Still Not Pre-Authorized!";
  // First bottom paragraph: full padding shorthand value.
  @Input() footerPara1Padding = "30px 68px 20px 68px";
  // First bottom paragraph text.
  @Input() footerPara1 =
    "Without pre-authorization, we will unfortunately have to cancel your appointment before your exam.";
  // Second bottom paragraph: full padding shorthand value.
  @Input() footerPara2Padding = "0 35px 10px 35px";
  // Second bottom paragraph text.
  @Input() footerPara2 =
    "We will continue to send you reminders for you to call your Physician's office and have them Pre-Authorize you with your Insurance company. We sincerely appreciate your cooperation with us on your pre-authorization process.";
}
